// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M4 2H20V22H4V2Z","strokeWidth":"props.strokeWidth","fill":"none"}},{"tag":"path","attrs":{"stroke":"#000","d":"M9 8H15M9 12H15M9 16H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"catalog"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 2L20 2L20 22L4 22L4 21L4 15L4 9L4 3L4 2Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 2H20V22H4V2Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 8H15M9 12H15M9 16H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CatalogIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'catalog',
    ref,
    icon: element,
  },
));

CatalogIcon.displayName = 'CatalogIcon';

export default CatalogIcon;
